import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { PaginationHeaderData } from 'src/app/models/pagination-header-data.model';
import { ServicePlan } from 'src/app/models/service_plan.model';
import { ServiceType } from 'src/app/models/service_type.model';
import { ShoppingService } from 'src/app/services/shopping.service';
import { RemoveFromCart } from 'src/app/store/actions';
import { AppState } from 'src/app/store/models/app-state.model';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from "@angular/material/expansion";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatLabel, MatSelect, MatOption, MatSelectModule } from "@angular/material/select";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardActions, MatCardContent, MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';

@Component({
	selector: 'app-shopping',
	templateUrl: './shopping.component.html',
	styleUrls: ['./shopping.component.scss'],
 imports: [
	MatAccordion, 
	MatExpansionPanel, 
	MatExpansionPanelHeader, 
	MatExpansionPanelTitle, 
	MatExpansionPanelDescription, 
	MatProgressBar, 
	MatLabel, 
	MatFormFieldModule, 
	MatSelect, 
	MatOption, 
	MatCheckbox, 
	MatCard, 
	MatCardTitle, 
	MatCardSubtitle, 
	MatCardActions, 
	MatCardContent, 
	ReactiveFormsModule, 
	FormsModule, 
	MatInputModule,
	MatButtonModule,
	MatCardModule,
	MatSelectModule,
	MatOptionModule
]
})
export class ShoppingComponent implements OnInit {
	servicePlans: ServicePlan[] = [];
	selectedServiceType: ServiceType | null = null;
	serviceTypes: ServiceType[] = [];
	orderByValues: any[] = [{ name: 'Lowest Priced', value: 'Rate' }, { name: 'Highest Priced', value: 'Rate DESC' }];
	selectedOrderBy: string = '';
	selectedState: string = '';
	hasSearched: boolean = false;
	pageNumber: number = 1;

	states: string[] = [];

	serviceTypeFormControl = new FormControl();
	businessNameFormControl = new FormControl();
	orderByFormControl = new FormControl('Lowest-Price');
	inOfficeAvailabilityFormControl = new FormControl(true);
	virtualAvailabilityFormControl = new FormControl(true);
	homeCareAvailabilityFormControl = new FormControl(true);
	hsaApprovedFormControl = new FormControl(false);
	stateFormControl = new FormControl('');

	isLoadedYet = false;
	loading = false;
	moreServicePlansToLoad: boolean = false;

	constructor(private shoppingService: ShoppingService,
		private store: Store<AppState>,
		private router: Router,
	) { };

	ngOnInit() {
		localStorage.setItem('ReturnToCheckout', 'false');
		this.getServiceTypes();
		this.getStates();
		this.getServicePlans()
	}

	getServiceTypes(): void {
		const blankServiceType: ServiceType = new ServiceType();
		blankServiceType.name = "All Service Types"

		this.loading = true;
		this.shoppingService
			.getAllShoppableServiceTypes(['All'], new Map([
				['isCustomer', 'true']
			]))
			.subscribe(serviceTypes => {
				this.serviceTypes = serviceTypes;
				this.serviceTypes.unshift(blankServiceType);
				this.loading = false;
			}, () => {
				this.loading = false;
			});
	}

	getStates(): void {
		const queryParams = new Map();

		this.shoppingService.getStates(['GetServiceProviderStates'], queryParams).subscribe((stateArray) => {
			this.states = stateArray;
			this.states.unshift('Any State');
		});
	}
	getServicePlans(): void {
		this.loading = true;
		const map = new Map();
		if (this.selectedServiceType?.serviceTypeId == null) {
			map.set('serviceTypeId', '');
		} else {
			map.set('serviceTypeId', this.selectedServiceType ? this.selectedServiceType.serviceTypeId : '');

		}

		if (this.businessNameFormControl) {
			map.set('businessName', this?.businessNameFormControl?.value ?? '');
		}

		if (this.selectedOrderBy) {
			map.set('orderBy', this.selectedOrderBy);
		}
		map.set('homeCareAvailability', this.homeCareAvailabilityFormControl.value);
		map.set('virtualAvailability', this.virtualAvailabilityFormControl.value);
		map.set('inOfficeAvailability', this.inOfficeAvailabilityFormControl.value);
		map.set('hsaApproved', this.hsaApprovedFormControl.value);

		if (this.selectedState == 'Any State') {
			map.set('state', '');
		} else {
			map.set('state', this.selectedState);
		}
		map.set('pagenumber', this.pageNumber);

		this.shoppingService.getShoppingServicePlans(["Shopping"], map).subscribe((result) => {
			let paginationData: PaginationHeaderData = JSON.parse(result.headers.get('x-pagination'));
			this.moreServicePlansToLoad = paginationData.hasNext;
			this.servicePlans = [...this.servicePlans, ...result.body];
			this.loading = false;
			this.isLoadedYet = true;
			this.hasSearched = true;
		}, () => {
			this.isLoadedYet = true;
			this.loading = false;
			this.hasSearched = true;
		});
	}

	routeToProductView(servicePlan: ServicePlan): void {
		if (servicePlan.appointmentType == 'Subscription') {
			this.router.navigate([`subscription-view/${servicePlan.servicePlanId}`]);
		}
		this.router.navigate([`product-view/${servicePlan.servicePlanId}`]);
	}

	initialLoad(): void {
		if (!this.isLoadedYet) {
			this.getServicePlans();
		}
	}

	removeFromCart(servicePlanId: string) {
		this.store.dispatch(new RemoveFromCart(servicePlanId));
	}

	loadMoreServicePlans(): void {
		this.pageNumber++;
		this.getServicePlans();
	}

	searchEnter(): void {
		this.pageNumber = 1;
		this.servicePlans = [];
		this.getServicePlans();
	}

	isMobile(): boolean {
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			return true;
		}
		else {
			return false;
		}
	}
}
